
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/insights/[uid]",
      function () {
        return require("private-next-pages/insights/[uid].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/insights/[uid]"])
      });
    }
  